import React, { useState } from 'react';
import UISectionWrapper, {
  UISectionHeader,
  UISectionBody,
} from '@/components/shared/UISectionWrapper';
import UISectionTitle from '@/components/shared/UISectionTitle';
import UIIconExtraButton from '@/components/shared/UIIconExtraButton';
import TasksCalendarTable from '../TaskCalendarTable';
import './TaskCalendarSection.scss';

export interface TasksCalendarData {
  id: string;
  date: string;
  execution: {
    status: 'PENDING' | 'DELAY' | 'DONE' | 'WARNING';
  };
  task: {
    name: string;
    type: 'PLUMBING' | 'ELECTRICITY' | 'MAINTENANCE' | 'CLEANING';
  };
  unit: string;
  property: {
    name: string;
    type?: 'residential' | 'commercial' | 'mixed';
  };
}

interface TasksCalendarSectionProps {
  id?: string,
  data?: TasksCalendarData[];
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onRowAction?: (id: string, action: string) => void;
}

// Мок-дані
const mockData: TasksCalendarData[] = [
  {
    id: '1',
    date: '2025-10-24',
    execution: { status: 'PENDING' },
    task: { name: 'Plumbing', type: 'PLUMBING' },
    unit: '203',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '2',
    date: '2025-10-01',
    execution: { status: 'PENDING' },
    task: { name: 'Electricity', type: 'ELECTRICITY' },
    unit: '204',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '3',
    date: '2024-10-01',
    execution: { status: 'DELAY' },
    task: { name: 'Electricity', type: 'ELECTRICITY' },
    unit: '205',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '4',
    date: '2024-10-01',
    execution: { status: 'DONE' },
    task: { name: 'Plumbing', type: 'PLUMBING' },
    unit: '206',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
  {
    id: '5',
    date: '2024-10-15',
    execution: { status: 'WARNING' },
    task: { name: 'Plumbing', type: 'PLUMBING' },
    unit: '207',
    property: { name: 'Arbre Magique', type: 'residential' },
  },
];

const mockHandlers = {
  onToggleCollapse: () => console.log('Toggle tasks calendar collapse'),
  onRowAction: (id: string, action: string) =>
    console.log('Tasks row action:', id, action),
};

const TasksCalendarSection: React.FC<TasksCalendarSectionProps> = ({
                                                                     id,
                                                                     data = mockData,
                                                                     isCollapsed = false,
                                                                     onToggleCollapse = mockHandlers.onToggleCollapse,
                                                                     onRowAction = mockHandlers.onRowAction,
                                                                   }) => {
  const baseClass = 'TasksCalendarSection';

  const headerAction = (
    <UIIconExtraButton
      icon={isCollapsed ? 'expand' : 'collapse'}
      onClick={onToggleCollapse}
      ariaLabel={isCollapsed ? 'Expand calendar' : 'Collapse calendar'}
    />
  );

  return (
    <UISectionWrapper
      className={baseClass}
      align="stretch"
      id={id}
    >
      <UISectionHeader>
        <UISectionTitle
          title="Tasks calendar"
          action={headerAction}
          showDivider={true}
        />
      </UISectionHeader>

      {!isCollapsed && (
        <UISectionBody>
          <div className={`${baseClass}__content`}>
            <TasksCalendarTable data={data} onRowAction={onRowAction} />
          </div>
        </UISectionBody>
      )}
    </UISectionWrapper>
  );
};

export default TasksCalendarSection;